<template>
  <l-map
    :options="leafletMapOptions"
    class="map"
    ref="map"
    @click="setRouteHome"
  >
    <l-tile-layer :url="mapStyleUrl"></l-tile-layer>
    <MarkerStreetNumber
      v-for="marker in markers"
      :key="marker.street_number"
      :marker="marker"
    >
    </MarkerStreetNumber>
  </l-map>
</template>

<script>
import { LMap, LTileLayer } from "vue2-leaflet";
import MarkerStreetNumber from "./Marker.vue";
import "leaflet/dist/leaflet.css";

export default {
  components: {
    LMap,
    LTileLayer,
    MarkerStreetNumber,
  },
  data() {
    return {
      loading: true,
      map: null,
      mapStyleUrl:
        "https://api.mapbox.com/styles/v1/theoesilab/cldylwp3k000401ur5bg18zk3/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoidGhlb2VzaWxhYiIsImEiOiJjbGR5bHR5emgwZTR1M25ud2RrdGJuenN4In0.qKf6Lj17GOrpe178eWRRww",
      leafletMapOptions: {
        center: [48.6025, 7.68],
        zoom: 18,
        minZoom: 17,
        maxZoom: 18,
        maxBounds: [
          [48.5995, 7.6711],
          [48.6055, 7.6911],
        ],
        zoomControl: false,
        attributionControl: false,
        tap: false,
      },
    };
  },

  methods: {
    setRouteHome() {
      this.$router.push({ name: "home" });
    },
  },

  computed: {
    markers() {
      return this.$store.getters.markers;
    },
  },
};
</script>

<style lang="scss">
.map {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>
